/**
 * Presentation shape + display constants for the nav discovery menu.
 *
 * Since the CO-515 beta-2 roster, per-room `name`/`description` are
 * SERVER-AUTHORED (the DB row is the single copy source) and required:
 * `useCirclesNavMenu` drops any option without a usable description via
 * `filterDescribedOptions` (shared/circleKeys) rather than inventing client
 * copy for it — the old per-category fallback map is gone. `capacity` keeps a
 * client fallback (below) because an absent value is a wire-tolerance case,
 * not a mis-provisioned row.
 */

/** One circle offered by the menu, after mapping the live query result. */
export interface NavMenuOption {
  /**
   * Circle key (mixed rooms 11–92, tenured 101–103; legacy bare 1–9 payloads
   * tolerated) — also the card's React key and the join argument.
   */
  rainbowCategoryKey: number
  name: string
  description: string
  memberCount: number
  capacity: number
}

/**
 * FALLBACK circle capacity. `OnboardingCircleOption.capacity` is the source of
 * truth since CO-515 Phase B; this covers a pre-Phase-B gateway. Mirrors
 * `CIRCLE_DEFAULT_CAPACITY` in services/community/circles/gql/adapters.ts
 * (Brooklyn's `community.circles.maxMembers`).
 */
export const NAV_MENU_CAPACITY = 24

/**
 * Display cap on the mixed (interest-room) tail — with ≤3 tenured rooms the
 * menu tops out around 9 cards; the card list scroll-contains
 * (`circles-nav-menu__scroll`, ~3 cards tall) so this is UX pacing, not
 * overflow safety. The server ranks mixed rooms per-viewer, so the first N
 * are the viewer's best N.
 */
export const NAV_MENU_MAX_MIXED_CARDS = 6
